import Request from 'src/utils/request'

// 获取日程列表
export function getDiagnosisRecordListApi (params) {
  return Request({
    url: '/follow/patientSchedule/list',
    method: 'get',
    unique: true,
    params
  })
}

export function getPlanPackageWorkOrderDetailApi (id, params) {
  return Request({
    url: `/follow/planPackageWorkOrder/${id}`,
    method: 'get',
    unique: true,
    params
  })
}

// 在线会诊工单详情
export function getOnlineConsultationWorkOrderDetailApi (id) {
  return Request({
    url: `/follow/onlineConsultationWorkOrder/${id}`,
    method: 'get'
  })
}

export function getPatientConsultingPageWorkOrderDetailApi (id, params) {
  return Request({
    url: `/follow/consulting/detail/${id}`,
    method: 'get',
    unique: true,
    params
  })
}

// 家庭医生工单不分页
export function getFamilyDoctorWorkOrderListApi (params) {
  return Request({
    url: '/follow/familyDoctorWorkOrder/list',
    method: 'get',
    params
  })
}

// 在线咨询工单不分页
export function postConsultingListWorkOrderApi (params) {
  return Request({
    url: '/follow/consulting/listWorkOrder',
    method: 'get',
    params
  })
}

// 在线会诊工单不分页
export function getOnlineConsultationWorkOrderListApi (params) {
  return Request({
    url: '/follow/onlineConsultationWorkOrder/list',
    method: 'get',
    params
  })
}

// 确认完成迁移
export function postPatientUpdateMigrationFlagApi (userId) {
  return Request({
    url: `/follow/patient/updateMigrationFlag/${userId}`,
    unique: true,
    method: 'post'
  })
}

// 开始迁移
export function postPatientScheduleAsyncOldSysApi (data) {
  return Request({
    url: '/follow/patientSchedule/asyncOldSys',
    method: 'post',
    data
  })
}
// 获取迁移状态
export function getPatientListByListApi (userId) {
  return Request({
    url: `/follow/patient/patient/list/${userId}`,
    unique: true,
    method: 'get'
  })
}

// 福利计划订单
export function getBenefitGuaranteePayPlanOrderPageApi (params) {
  return Request({
    url: '/follow/benefitGuaranteePayPlan/order/page',
    method: 'get',
    params
  })
}

// 就医安排订单
export function getPatientMedicalClinicOrderListApi (params) {
  return Request({
    url: '/follow/planPackageWorkOrder/page',
    method: 'get',
    params
  })
}

// 在线咨询订单
export function getPatientConsultingPageWorkOrderApi (params) {
  return Request({
    url: '/follow/consulting/pageWorkOrder',
    method: 'get',
    unique: true,
    params
  })
}

// 在线会诊订单
export function getOnlineConsultationWorkOrderPageNewApi (params) {
  return Request({
    url: '/follow/onlineConsultationWorkOrder/page',
    method: 'get',
    params
  })
}

// 数据统计
export function getPatientDataStatisticsApi (params) {
  return Request({
    url: '/follow/patient/dataStatistics',
    method: 'get',
    params
  })
}
export function getBenefitGuaranteePayPlanCardPacksApi (params) {
  return Request({
    url: '/follow/benefitGuaranteePayPlan/getCardPacks',
    method: 'get',
    params
  })
}

// 在线咨询订单-老
export function postQueryHousePatientQuestionListOldApi (data) {
  return Request({
    url: '/api/query/house/patient/question/list',
    method: 'post',
    isOld: true,
    data
  })
}
// 在线会诊订单-老
export function getZxhzListOldApi (params) {
  return Request({
    url: '/follow-up/api/v1/online/consultation/work/order/page',
    method: 'get',
    params
  })
}

// 患者工作台-记录-最新
export function getPatientWorkbenchRecordLatestListApi (params) {
  return Request({
    url: '/follow/patientWorkbenchRecord/latestList',
    method: 'get',
    params
  })
}

// 患者工作台管理
export function postPatientWorkbenchRecordApi (data) {
  return Request({
    url: '/follow/patientWorkbenchRecord/add',
    method: 'post',
    data
  })
}

// 系统用户列表
export function getSystemUserListApi (params) {
  return Request({
    url: '/follow/systemUser/list',
    method: 'get',
    params,
    unique: true
  })
}
